import React, { useEffect, useState } from 'react';
import './ContactBanner.css';

const ContactBanner = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return isMobile ? (
    // === Mobile Version ===
    <section className="contact-banner contact-banner--mobile">
      <img
        src="/assets/cnbg.png"
        alt="Background Drip"
        className="contact-banner-drip"
        aria-hidden="true"
      />
      {/* <div className="contact-banner-text">Contact</div> */}
    </section>
  ) : (
    // === Desktop Version ===
    <section
      className="contact-banner"
      style={{
        background: "url('/assets/conbg.png') no-repeat center center / cover",
      }}
    >
      <div className="contact-banner-text">Contact <br /> Us</div>
    </section>
  );
};

export default ContactBanner;
